import React from 'react';

export default function Canvas(props) {
  return (
    <main className="bg-slate-700 flex justify-center items-center">
      <canvas id="canvas" />
    </main>
  )
}